import { WithTimeUnit } from '@mews-commander/types';
import { DateTime, lt } from '@mews/framework';
import HeaderCell from '../Cells/HeaderCell';
import { GuestsHeaderCellElement } from '../Cells/styles';

interface Props extends WithTimeUnit {
    dateTimeRange: Array<DateTime>;
    occupancyInBlocksEnabled: boolean;
    isEditingAvailability: boolean;
}

export const renderHeader = ({ dateTimeRange, timeUnit, occupancyInBlocksEnabled, isEditingAvailability }: Props) => {
    const dateTimeHeaderCells = dateTimeRange.map((dateTime: DateTime) => (
        <HeaderCell key={dateTime.value} date={dateTime} timeUnit={timeUnit} />
    ));
    return occupancyInBlocksEnabled && isEditingAvailability
        ? [<GuestsHeaderCellElement>{lt('GuestPlural')}</GuestsHeaderCellElement>, ...dateTimeHeaderCells]
        : dateTimeHeaderCells;
};
